import { render } from "./BasePlaylistSong.vue?vue&type=template&id=609d5bae&scoped=true"
import script from "./BasePlaylistSong.vue?vue&type=script&lang=js"
export * from "./BasePlaylistSong.vue?vue&type=script&lang=js"

import "./BasePlaylistSong.vue?vue&type=style&index=0&id=609d5bae&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609d5bae"]])

export default __exports__